module.exports = __webpack_public_path__ + "img/weather62.b59eddfc.png";